import { render } from "./SexoDropdown.vue?vue&type=template&id=172c71c1&scoped=true"
import script from "./SexoDropdown.vue?vue&type=script&lang=js"
export * from "./SexoDropdown.vue?vue&type=script&lang=js"

import "./SexoDropdown.vue?vue&type=style&index=0&id=172c71c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172c71c1"]])

export default __exports__